import api from '@/api';
import {
  BankAccountContact,
  BankAccountContactCreate,
  BankAccountContactDelete,
  BankAccountContactDeleteDetail,
} from './BankAccountContacts.types';
import { API_BASE_URL } from '..';

const CONTROLLER_URL = `${API_BASE_URL}/bankAccounts`;

const bankAccountContactsServices = {
  async list(bankAccountId?: number) {
    const result = (await api.get(
      `${CONTROLLER_URL}/${bankAccountId}/contacts`,
      null,
    )) as unknown;

    return result as BankAccountContact[];
  },

  async create(data: BankAccountContactCreate) {
    const result = (await api.post(
      `${CONTROLLER_URL}/${data.bankAccountId}/contacts`,
      data,
    )) as unknown;

    return result as BankAccountContact;
  },

  async edit(data: BankAccountContact) {
    const result = (await api.put(
      `${CONTROLLER_URL}/${data.bankAccountId}/contacts/${data.id}`,
      data,
      null,
    )) as unknown;

    return result as BankAccountContact;
  },

  async remove(params: BankAccountContactDelete) {
    const result = (await api.remove(
      `${CONTROLLER_URL}/${params.bankAccountId}/contacts/${params.id}`,
      {},
      null,
    )) as unknown;

    return result as void;
  },

  async removeDetail(params: BankAccountContactDeleteDetail) {
    const result = (await api.remove(
      `${CONTROLLER_URL}/${params.bankAccountId}/contacts/contactDetail/${params.detailId}`,
      {},
      null,
    )) as unknown;

    return result as void;
  },
};

export default bankAccountContactsServices;
